var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var featherlight = require( 'featherlight' );

var ModuleVideo = function () {
    this.$videoPopUpActivator = $( '.module-video a' );
};

ModuleVideo.prototype.init = function () {
    var self = this;
    self.$videoPopUpActivator.featherlight( {
        type: 'iframe'
    } );
};

module.exports = new ModuleVideo();
